import { render, staticRenderFns } from "./RadioComponent.vue?vue&type=template&id=c3fcb7de"
import script from "./RadioComponent.vue?vue&type=script&lang=ts"
export * from "./RadioComponent.vue?vue&type=script&lang=ts"
import style0 from "./RadioComponent.vue?vue&type=style&index=0&id=c3fcb7de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports